import React, { useState } from 'react';
import { Stack, Button, IconButton } from '@mui/material';
import { Pages, useRouteMatch } from '../utils/routes.utils';
import { useNavigate } from 'react-router-dom';

import Instagram from '../assets/icons/instagram.svg';

interface TabbarProps {
  routes: { label: string, path: string }[];
  handleChange?: () => void;
}

const Tabbar = (props: TabbarProps) => {

  const { routes, handleChange } = props;

  const currentTab = useRouteMatch(routes.map((route) => route.path));

  const navigate = useNavigate();

  return (
    <>
      <svg style={{position: 'absolute', width: 0, height: 0}}>
        <defs>
          <filter id="tabbarRoughEdges">
            <feMorphology operator="dilate" radius="8" in="SourceAlpha" result="dilated" />
            <feTurbulence type="fractalNoise" baseFrequency="0.03" numOctaves="3" result="noise" />
            <feDisplacementMap in="dilated" in2="noise" scale="8" xChannelSelector="R" yChannelSelector="G" result="displaced" />
            <feFlood floodColor="#000000" result="black" />
            <feComposite in="black" in2="displaced" operator="in" result="blackShape" />
            <feMerge>
              <feMergeNode in="blackShape" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
      </svg>
      <Stack
        direction='row'
        alignItems='center'
        padding={{xs: 2, sm: 3, md: 4}}
        justifyContent='center'
        gap={1}
        display={"flex"}
        >
        <Stack direction='row' position={{xs: 'relative', sm: 'absolute'}} sx={{left: {sm: '20px'}}} gap={1}>
          <IconButton
            onClick={() => {
              window.location.href = 'https://www.instagram.com/folksfestivalmarseille/'
            }}
            sx={{
              height: {xs: '30px', md: '44px'},
              width: {xs: '30px', md: '44px'}
            }}>
            <img src={Instagram} alt=''
            style={{
              filter: 'grayscale(100%) brightness(0)',
            }}
            width="100%"
            height="100%"/>
          </IconButton>
        </Stack>
        <Button
          onClick={() => navigate('/homepage')}
          sx={{
            fontSize: { xs: '12px', md: '16px' },
            textTransform: 'none',
            fontWeight: 700,
            filter: currentTab === Pages.HOMEPAGE ? 'url(#tabbarRoughEdges)' : 'none',
            letterSpacing: '0.05em',
            fontFamily: 'DroulersClarendon-Line',
            color: currentTab === Pages.HOMEPAGE ? '#F9423A' : '#000',
            textShadow: 'none'
          }}>
          Accueil
        </Button>
        <Button
          onClick={() => navigate('/programmation')}
          sx={{
            fontSize: { xs: '12px', md: '16px' },
            textTransform: 'none',
            fontWeight: 700,
            filter: currentTab === Pages.PROG ? 'url(#tabbarRoughEdges)' : 'none',
            letterSpacing: '0.05em',
            fontFamily: 'DroulersClarendon-Line',
            color: currentTab === Pages.PROG ? '#F9423A' : '#000',
            textShadow: 'none'
          }}>
          Programmation & billetterie
        </Button>
        <Button
          onClick={() => navigate('/about')}
          sx={{
            fontSize: { xs: '12px', md: '16px' },
            textTransform: 'none',
            fontWeight: 700,
            filter: currentTab === Pages.ABOUT ? 'url(#tabbarRoughEdges)' : 'none',
            letterSpacing: '0.05em',
            fontFamily: 'DroulersClarendon-Line',
            color: currentTab === Pages.ABOUT ? '#F9423A' : '#000',
            textShadow: 'none'
          }}>
          À propos
        </Button>
      </Stack>
    </>
  )
}

export default Tabbar;